import common from './common'
import rateQuery from './rate-query'
import inquiry from './inquiry'
import quotation from './quotation'
import inquiryQuote from './inquiry-quote'
import shokzInquiry from './shokz-inquiry'
import shokzQuotation from './shokz-quotation'
import contract from './contract'
import rateManagement from './rate-management'
import other from './other'
import supplierManagement from './supplier-management'
import surchargeManagement from './surcharge-management'
import rateWarehouse from './rate-warehouse'
import shokzRateQuery from './shokz-rate-query'

export default {
  ...common,
  ...rateQuery,
  ...inquiry,
  ...quotation,
  ...inquiryQuote,
  ...shokzInquiry,
  ...shokzQuotation,
  ...contract,
  ...rateManagement,
  ...other,
  ...supplierManagement,
  ...surchargeManagement,
  ...rateWarehouse,
  ...shokzRateQuery
}
